import React from "react";
import styles from "./hero.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import dynamic from "next/dynamic";

const CountdownTimer = dynamic(
  () => import("@unisearch/common/countdown_timer"),
  {
    ssr: false,
  }
);

export const EventHero = ({ goToBookNow, goToviewLocation, ...props }) => {
  return (
    <section
      className={styles.section_hero}
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1561489396-888724a1543d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)",
      }}
    >
      <div className={styles.hero_overlay_wrapper}>
        <div className={`container ${styles.hero_content_wrapper}`}>
          <div className={`${styles.hero_content}`}>
            <div className={`${styles.hero_content_left}`}>
              <div className={`${styles.hero_content_left_date}`}>05</div>
              <div
                style={{ width: "70%" }}
                className={`${styles.hero_content_left_line}`}
              ></div>
              <div className={`${styles.hero_content_left_date}`}>Sep</div>
              <div className={`${styles.hero_content_left_line}`}></div>
              <div
                className={`${styles.hero_content_left_date} ${styles.hero_content_left_year}`}
              >
                2023
              </div>
            </div>
            <div className={`${styles.hero_content_right}`}>
              <p>International Conference on</p>
              <h1>New Trends in Teaching, Learning & Education</h1>

              <div className={`${styles.hero_content_right_building}`}>
                <ReactSVG src={getAssets("assets/icons/office-building.svg")} />
                <div className={styles.address}>
                  Hilton Nashville Airport Hotel, Nashville, TN
                </div>
              </div>

              <div className={`${styles.btn_wrapper}`}>
                <button
                  onClick={goToBookNow}
                  className="btn btn-secondary btn-bg"
                >
                  Book Now
                </button>
                <button
                  onClick={goToviewLocation}
                  className="btn btn-white btn-bg"
                >
                  View Location
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.hero_footer_wrapper}>
          <div className={` ${styles.hero_footer_content_wrapper}`}>
            <div className={`${styles.hero_footer_content}`}>
              <div className={styles.start}>Starting in:</div>
              <CountdownTimer
                customClasses={{
                  root: styles.timer_root,
                  counter_number: styles.counter_number,
                  counter_text: styles.count_text,
                }}
                targetDate={"02/26/2023"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHero;
